import { FC, ReactNode, useEffect, useRef } from "react";
import Logo from "../../assets/img/Logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { NON_AUTH_ROUTE } from "../../pages/App/routes";
import LeftArrow from "../../components/UI/Icons/LeftArrow";
import CustomButton from "../../components/UI/Buttons/CustomButton";

/**
 * @interfaces EnquiryProps
 * to submit the enquiry
 */
interface EnquiryProps {
  children?: ReactNode;
}

const Enquiry: FC<EnquiryProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [location]);

  const handleLoginPage = () => {
    navigate(NON_AUTH_ROUTE.LOGIN);
  };

  return (
    <>
      <div className="d-flex flex-column flex-lg-row justify-content-center">
        <div
          className="welcome-bg min-w-410px mobile-w-100 vh-100 p-20px d-flex flex-column justify-content-between"
          style={{ backgroundPosition: "right center" }}
        >
          <div className="d-flex p-30px">
            <CustomButton
              variant={"primary"}
              type="button"
              className="btn-theme bg-off-white text-black"
              onClick={handleLoginPage}
            >
              <LeftArrow /> Return to Login Page
            </CustomButton>
          </div>
          <div className="fs-40 fw-400 text-white px-30px">
            Submit an Enquiry
          </div>
          <div className="d-none d-lg-flex gap-10 align-items-center position-relative">
            <div className="fs-13 fw-400 text-white">
              &copy; {new Date().getFullYear()} Connected Crew
            </div>
            <div className="w-1px h-20px bg-white"></div>
            <Link
              to={NON_AUTH_ROUTE.PRIVACY_POLICY_ENQUIRY}
              className="fs-13 fw-400 text-white text-decoration-none"
            >
              Privacy Policy
            </Link>
            <div className="w-1px h-20px bg-white"></div>
            <Link
              to={NON_AUTH_ROUTE.TERMS_OF_SERVICE_ENQUIRY}
              className="fs-13 fw-400 text-white text-decoration-none"
            >
              Terms of Service
            </Link>
          </div>
        </div>
        <div ref={scrollRef} className="w-100 vh-100 overflow-auto">
          <div
            className={`d-flex flex-column p-50px gap-30 ${
              location.pathname.includes("success") &&
              "vh-100 justify-content-center"
            }`}
          >
            <img
              src={Logo}
              width={120}
              height={36}
              alt="Logo"
              className="img-fluid"
            />
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Enquiry;
